<ng-template #exportReportsModal let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title">{{ 'EXPORT.REPORTS.TITLE' | translate }}</h5>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');">
        <span aria-hidden="true">&times;</span>&nbsp;
        <span>{{ 'COMMON.CLOSE' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="modal-body" *ngIf="!showLoader">
    <div class="container my-3">

      <div class="form-group">
        <div class="row">
          <div class="col-12">

            <!-- Instrucciones -->
            <div class="alert alert-warning" role="alert" [innerHtml]="'EXPORT.REPORTS.INSTRUCTIONS' | translate" *ngIf="currentConsultant.raas.nameid"></div>
            <div class="alert alert-warning" role="alert" [innerHtml]="'EXPORT.REPORTS.INSTRUCTIONS_EMAIL' | translate" *ngIf="!currentConsultant.raas.nameid"></div>

            <form [formGroup]="exportReportForm" id="exportReportForm" (ngSubmit)="getExportReport()">

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label for="reportType">{{'REPORTS.REPORTTYPE' | translate}}: *</label>
                  <select class="form-control" id="reportType" formControlName="reportType">
                    <option [ngValue]="1" *ngIf="!onlyEvalualia">{{'REPORTS.REPORTTYPES.PARTICIPANT' | translate}}</option>
                    <option [ngValue]="2">{{'REPORTS.REPORTTYPES.CONSULTANT' | translate}}</option>
                    <option [ngValue]="3" *ngIf="!onlyEvalualia">{{'REPORTS.REPORTTYPES.CLIENT' | translate}}</option>
                  </select>
                </div>
              </div>

              <ng-container *ngIf="exportReportForm.get('reportType').value !== 1">
                <div class="form-row form-group mb-3">

                  <!-- Perfiles ideales normativos -->
                  <div class="col-lg-6" *ngIf="showSelectNr">
                    <label for="idealProfileNr">{{'REPORTS.IDEALPROFILEADJUSTNR' | translate}}:</label>
                    <div class="row">
                      <div class="col-1 mt-2">
                        <input name="adjustmentNr" formControlName="adjustmentNr" class="idealProfileCheckbox"
                          type="checkbox" (click)="!exportReportForm.get('adjustmentNr').value ? utilsService.toast('warning', 'EXPORTREPORTJOBTYPESNR'): null"/>
                      </div>
                      <div class="col-10">
                        <select class="form-control" id="idealProfileNr" formControlName="idealProfileNr"
                          [attr.disabled]="exportReportForm.get('adjustmentNr').value ? null: ''">
                          <option disabled value=null>{{ 'REPORTS.SELECTIDEALPROFILE' |translate }}</option>
                          <option *ngFor="let idealProfile of idealProfilesNr" [ngValue]="idealProfile.id"
                            [ngClass]="{'isUB': idealProfile.isUb}">
                            {{ idealProfile.name || idealProfile.Name}}</option>
                        </select>
                      </div>

                    </div>
                  </div>

                  <!-- Perfiles Ideales Ipsativos -->
                  <div class="col-lg-6" *ngIf="showSelectIp">
                    <label for="idealProfileIp">{{'REPORTS.IDEALPROFILEADJUSTIP' | translate}}:</label>
                    <div class="row">
                      <div class="col-1 mt-2">
                        <input name="adjustmentIp" formControlName="adjustmentIp" class="idealProfileCheckbox"
                          type="checkbox" />
                      </div>
                      <div class="col-10">
                        <select class="form-control" id="idealProfileIp" formControlName="idealProfileIp"
                          [attr.disabled]="exportReportForm.get('adjustmentIp').value ? null: ''">
                          <option disabled value=null>{{ 'REPORTS.SELECTIDEALPROFILE' |translate }}</option>
                          <option *ngFor="let idealProfile of idealProfilesIp" [ngValue]="idealProfile.id"
                            [ngClass]="{'isUB': idealProfile.isUb}">
                            {{ idealProfile.name || idealProfile.Name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label for="reportLanguageId">{{'COMMON.LANGUAGE' | translate}}: *</label>
                  <select class="form-control" id="reportLanguageId" formControlName="reportLanguageId">
                    <option [value]="[5,7].includes(currentConsultant.client.id) ? 1 : currentConsultant.client.id">{{'LANGUAGE.SPANISH' | translate}}</option>
                    <option [value]="7" *ngIf="!onlyEvalualia">{{'LANGUAGE.ENGLISH' | translate}}</option>
                    <option [value]="5" *ngIf="!onlyEvalualia">{{'LANGUAGE.PORTUGUESE' | translate}}</option>
                  </select>
                </div>
              </div>

              <div *ngIf="HCC.includes(officeId)" class="form-row">
                <div class="form-group col-12">
                  <label for="projectId">{{'COMMON.PROJECT' | translate}}:</label>
                  <select class="form-control" id="projectId" formControlName="projectId">
                    <option [ngValue]="null">{{ 'INVITE.PROJECTNOTSELECTED' | translate }}</option>
                    <ng-container *ngFor="let project of projects">
                      <option *ngFor="let children of project.children" [ngValue]="children.id">
                        {{ children.name + ' - ' + children.description }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>

              <hr class="my-4">
              <button type="button" class="btn btn-light mr-3" (click)="modal.dismiss('cancel click')">
                {{ 'COMMON.CANCEL' | translate }}
              </button>
              <button type="submit" form="exportReportForm" class="btn btn-primary"
                [disabled]="(exportReportForm.get('adjustmentNr').value && !exportReportForm.get('idealProfileNr').value) ||
                (exportReportForm.get('adjustmentIp').value && !exportReportForm.get('idealProfileIp').value)"
              >
                {{ 'COMMON.CONFIRM' | translate }}
              </button>

            </form>

          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-body" *ngIf="showLoader">
    <div class="container my-3">
      <div class="form-group">
        <div class="row justify-content-center">
          <div class="loading-overlay-spinner"></div>
        </div>
        <p class="text-center mt-3"> {{'EXPORT.SCORES.PHRASE' | translate }} </p>
      </div>
    </div>
  </div>
</ng-template>
